import { SvgIcon, SvgIconProps } from '@mui/material'

export const UpsellIcon = {
  Fire: (props: SvgIconProps) => {
    return (
      <SvgIcon viewBox="0 0 24 24" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M2.54058 11.7047C2.54058 11.7047 3.48877 13.0977 5.47608 14.2768C5.47608 14.2768 4.03678 2.11261 13.4147 0C11.0121 8.81817 16.471 11.305 18.4609 6.64622C21.784 11.083 19.2608 14.9538 19.2608 14.9538C20.6235 15.1501 21.768 13.6615 21.768 13.6615C21.7783 13.8449 21.784 14.0295 21.784 14.2155C21.784 19.6193 17.4033 24 11.9994 24C6.59555 24 2.21484 19.6193 2.21484 14.2154C2.21484 13.3474 2.32847 12.506 2.54058 11.7047Z"
            fill="#FF6536"
          />
          <path
            d="M21.7687 13.6615C21.7687 13.6615 20.6241 15.1501 19.2615 14.9538C19.2615 14.9538 21.7846 11.083 18.4615 6.64622C16.4716 11.305 11.0127 8.81817 13.4153 0C12.9131 0.113156 12.4421 0.255328 12 0.422719V24C17.4039 24 21.7846 19.6193 21.7846 14.2154C21.7846 14.0295 21.7789 13.8449 21.7687 13.6615Z"
            fill="#FF421D"
          />
          <path
            d="M7.70898 19.7088C7.70898 22.0787 9.6302 24 12.0001 24C14.37 24 16.2912 22.0787 16.2912 19.7088C16.2912 18.4404 15.7409 17.3005 14.8659 16.5149C13.2068 18.7689 10.8425 15.3497 12.685 12.8529C12.685 12.8529 7.70898 13.4765 7.70898 19.7088Z"
            fill="#FBBF00"
          />
          <path
            d="M16.2911 19.7088C16.2911 18.4404 15.7408 17.3005 14.8657 16.5149C13.2067 18.7689 10.8424 15.3497 12.6849 12.8529C12.6849 12.8529 12.4146 12.8869 12 13.0177V24C14.3699 24 16.2911 22.0787 16.2911 19.7088Z"
            fill="#FFA900"
          />
        </svg>
      </SvgIcon>
    )
  },
  Clock: (props: SvgIconProps) => {
    return (
      <SvgIcon viewBox="0 0 24 24" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path
            d="M14.8664 5.53285L15.5722 4.82712C15.8464 4.55287 15.8464 4.1082 15.5722 3.83409C15.2979 3.55984 14.8534 3.55984 14.5791 3.83409L13.8734 4.53983C12.6893 3.55325 11.2505 2.95724 9.71576 2.81772V1.40446H10.3946C10.7824 1.40446 11.0967 1.08998 11.0967 0.702164C11.0967 0.314346 10.7824 0 10.3946 0H7.63248C7.24466 0 6.93031 0.314346 6.93031 0.702164C6.93031 1.08998 7.24466 1.40446 7.63248 1.40446H8.31129V2.81772C4.46938 3.16708 1.40625 6.39459 1.40625 10.3927C1.40625 14.5971 4.80858 18 9.0136 18C13.2179 18 16.6208 14.5977 16.6208 10.3927C16.6208 8.59666 16.0023 6.89584 14.8664 5.53285ZM9.01346 16.5955C5.59328 16.5955 2.81058 13.813 2.81058 10.3927C2.81058 6.97247 5.59328 4.18991 9.01346 4.18991C12.4338 4.18991 15.2163 6.97247 15.2163 10.3927C15.2163 13.813 12.4338 16.5955 9.01346 16.5955ZM12.2677 7.1385C12.542 7.41275 12.542 7.85742 12.2677 8.13153L9.51004 10.8892C9.23579 11.1635 8.79112 11.1635 8.51701 10.8892C8.24277 10.615 8.24277 10.1703 8.51701 9.89621L11.2746 7.1385C11.5488 6.86426 11.9935 6.86426 12.2677 7.1385Z"
            fill="currentColor"
          />
        </svg>
      </SvgIcon>
    )
  },
}
